import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import NewAssignmentConfigurations from '../NewAssignmentConfiguration/AssignmentConfiguration';
import NewAttachment from '../../AssignmentSubmission/NewAttachment/Attachment';

const NewCollapsibleAssignmentDescription = ({
  description,
  attachment,
  attachmentRequired,
  commentRequired,
  isExpanded,
  maxScore,
  gradable,
}) => {
  const { t } = useTranslation();
  if (!isExpanded) {
    return null;
  }
  return (
    <div className="description__wrapper">
      <div data-testid="collapsible-container-id">
        <div className="description__label">{t('Assignment Description')}</div>
        <div
          className="description__description"
          data-testid="assignmentDescription"
        >
          {description}
        </div>
        <div className="description__attachment_wrapper">
          {attachment && <NewAttachment attachment={attachment} />}
        </div>
        <NewAssignmentConfigurations
          attachmentRequired={attachmentRequired}
          commentRequired={commentRequired}
          maxScore={maxScore}
          gradable={gradable}
        />
      </div>
    </div>
  );
};

NewCollapsibleAssignmentDescription.defaultProps = {
  attachment: null,
  maxScore: null,
};

NewCollapsibleAssignmentDescription.propTypes = {
  attachment: PropTypes.object,
  description: PropTypes.string.isRequired,
  attachmentRequired: PropTypes.bool.isRequired,
  commentRequired: PropTypes.bool.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  maxScore: PropTypes.number,
  gradable: PropTypes.bool.isRequired,
};

export default NewCollapsibleAssignmentDescription;
